import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const TABLES_CONFIGURATION_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_TABLES_CONFIGURATION_MGMT,
  STEP_ONE: ROUTES.ADMIN_TABLES_CONFIGURATION_MGMT,
  CONFIGURE_TABLES:
    ROUTES.ADMIN_TABLES_CONFIGURATION_MGMT + "/configure-tables",
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
  CONFIGURE_TABLES: "configureTables",
  SELECTED_TYPE: "selectedType",
  DATA_IDENTIFIER: "data",
  VISIBLE_IDENTIFIER: "visibility",
  POSITION_IDENTIFIER: "position",
  LOADER_IDENTIFIER: "loader",
  CALL_STATE: "callState",
  COLUMNS_IDENTIFIER: "columns",
};

export const TABLES_CONFIGURATION_MGMT_USER_TYPES = {
  USER: "BASIC_USER",
  ADMIN: "ADMIN",
};
